import React from 'react';

const Footer = () => {
  return (
    <footer className="fixed bottom-0 left-0 right-0 text-white py-2 px-3 z-40" style={{ background: 'linear-gradient(135deg, #343232 0%, #1a1a1a 100%)' }}>
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-1 sm:gap-2">
        {/* Left Section - Copyright */}
        <div className="text-xs sm:text-sm text-gray-300 text-center sm:text-left">
          © {new Date().getFullYear()} All Rights Reserved | Built with dedication by{' '}
          <a
            href="https://thinktanker.io"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#EBA3A0] hover:text-[#F2C4C2] transition-colors cursor-pointer hover:underline"
          >
            THINKTANKER®
          </a>
        </div>

        {/* Right Section - Links */}
        <div className="flex items-center gap-2 sm:gap-3 text-xs sm:text-sm text-gray-300">
          <a
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#EBA3A0] transition-colors duration-200 cursor-pointer hover:underline"
          >
            Privacy Policy
          </a>
          <a
            href="/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#EBA3A0] transition-colors duration-200 cursor-pointer hover:underline"
          >
            Terms of Use
          </a>
          <a
            href="/terms-conditions"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#EBA3A0] transition-colors duration-200 cursor-pointer hover:underline"
          >
            Terms & Conditions
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
